function handleize(str) {
  if (str.includes('Turkey')) {
    return 'turkey';
  }
  return str
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-');
}
document.addEventListener('DOMContentLoaded', function () {
  window.showOverlay = function (overlayId, event, productName, countriesCovered, productUrl) {
    event.stopPropagation();
    event.preventDefault();
    const targetOverlay = document.getElementById(overlayId);
    if (overlayId === 'countriesCovered') {
      const countriesCoveredList = targetOverlay.querySelector('.countries-covered-list ul');
      countriesCoveredList.replaceChildren();
      const countriesCoveredArray = countriesCovered.split('|');
      const fragment = document.createDocumentFragment();
      countriesCoveredArray.forEach((country) => {
        const li = document.createElement('li');
        li.id = handleize(country);
        const img = document.createElement('img');
        img.src = `https://cdn.shopify.com/s/files/1/0582/6081/6062/files/${handleize(country)}.svg`;
        img.alt = `${country} Flag`;
        img.classList.add('flag-svg');
        li.innerText = country;
        li.append(img);
        fragment.append(li);
      });

      countriesCoveredList.append(fragment);
      const viewPlanBtn = targetOverlay.querySelector('.overlay-plan-btn');
      viewPlanBtn.setAttribute('href', productUrl);
      viewPlanBtn.onclick = function (e) {
        e.preventDefault();
        e.stopPropagation();
        window.location.href = productUrl;
      };
      targetOverlay.querySelector('.countries-covered-title').innerText = productName;
    }
    targetOverlay.classList.add('active');
    targetOverlay.style.display = 'block';
    document.body.classList.add('modal-open');
  };

  window.closeOverlay = function (overlayId, event) {
    event.stopPropagation();
    event.preventDefault();
    const targetOverlay = document.getElementById(overlayId);
    targetOverlay.style.display = 'none';
    document.body.classList.remove('modal-open');
  };

  window.onclick = function (event) {
    const overlays = document.querySelectorAll('.overlay');
    overlays.forEach((overlay) => {
      if (event.target === overlay) {
        overlay.style.display = 'none';
      }
    });
  };
});
